export enum SelfOrderInvoiceStatusTypesEnum {
  OPEN = 'OPEN',
  IN_PREPARATION = 'PREPARATION',
  READY = 'READY',
}
